import {createModel} from '~~/package/utils/ModelUtil';
import Model from '~~/package/mapper/Model';

export class AssessmentSummaryModel extends Model {
  constructor(
    public candidatesSummary: CandidateSummary = new CandidateSummary(),
    public averageSummary: AverageSummary = new AverageSummary(),
    public resultSummary: string = "",
    public trackDescriptions: TrackLevelSummary[] = []
  ){
    super();
  }

  public static create(model: Partial<AssessmentSummaryModel>): AssessmentSummaryModel {
    return createModel<AssessmentSummaryModel>(AssessmentSummaryModel, {
      ...model
    });
  }
}

class CandidateSummary {
  constructor(
      public total: number = 0,
      public completed: number = 0,
      public completedRate: number = 0
  ) {
  }
}

class AverageSummary {
  constructor(
      public score: number = 0,
      public takeTime: number = 0,
      public totalTakeTime: number = 0,
      public skillAcquisitionRate: number = 0
  ) {
  }
}

class TrackLevelSummary {
  constructor(
      public trackId: number = 0,
      public trackLevelName: string = "",
      public trackName: string = "",
      public trackLevelDescription: string = ""
  ) {
  }
}